export const getStorageKey = (dealWorkerId) => `newDealIds_${dealWorkerId}`;

export const persistNewDealIds = (dealWorkerId, ids) => {
	localStorage.setItem(getStorageKey(dealWorkerId), JSON.stringify(ids));
};

export const readNewDealIds = (dealWorkerId) => {
	const key = getStorageKey(dealWorkerId);

	return JSON.parse(localStorage.getItem(key) || '[]');
};
